<template>
  <div class="certificate-detail">
    <div class="container">
      <!-- title -->
      <p class="apply-title">考生信息</p>
      <ul class="a-list">
        <li class="item clearfix">
          <span class="a-title">姓名：</span>
          <span class="a-info">{{ data.student_name || data.name }}</span>
        </li>
        <li class="item clearfix" v-if="data.student_pinyin">
          <span class="a-title">姓名全拼：</span>
          <span class="a-info">{{ data.student_pinyin }}</span>
        </li>
        <li class="item clearfix" v-if="data.student_gender">
          <span class="a-title">性别：</span>
          <span class="a-info" v-if="data.student_gender === 0">男</span>
          <span class="a-info" v-if="data.student_gender === 1">女</span>
        </li>
        <li class="item clearfix" v-if="data.gender_title">
          <span class="a-title">性别：</span>
          <span class="a-info">{{ data.gender_title }}</span>
        </li>
        <li class="item clearfix">
          <span class="a-title">出生日期：</span>
          <span class="a-info">{{ data.student_birth || data.birth }}</span>
        </li>
        <li class="item clearfix" v-if="data.nation_title">
          <span class="a-title">民族：</span>
          <span class="a-info">{{ data.nation_title }}</span>
        </li>
        <li class="item clearfix" v-if="data.country_title">
          <span class="a-title">国籍：</span>
          <span class="a-info">{{ data.country_title }}</span>
        </li>
        <!-- <li class="item clearfix">
					<span class="a-title">身份证号/其他证件号：</span>
					<span class="a-info">{{}}</span>
				</li> -->
      </ul>
      <!-- title -->
      <hr />
      <p class="apply-title">考级信息</p>
      <ul class="a-list">
        <!-- <li class="item clearfix">
					<span class="a-title">报考考级机构：</span>
					<span class="a-info">{{data.agent_title}}</span>
				</li> -->
        <li class="item clearfix">
          <span class="a-title">考级专业：</span>
          <span class="a-info">{{ data.subject_title }}</span>
        </li>
        <li class="item clearfix">
          <span class="a-title">起止级：</span>
          <span class="a-info">{{ data.subject_range || "1-9" }}</span>
        </li>
        <li class="item clearfix">
          <span class="a-title">等级：</span>
          <span class="a-info">{{ data.rank_result || data.rank }}</span>
        </li>
        <li class="item clearfix">
          <span class="a-title">发证日期：</span>
          <span class="a-info">{{ data.give_time || data.granted_at }}</span>
        </li>
        <li class="item clearfix">
          <span class="a-title">证书编号：</span>
          <span class="a-info">{{ data.code || data.cert_no }}</span>
        </li>
      </ul>

      <div class="btn-wrap clearfix">
        <el-button type="primary" class="btn" @click="$router.go(-1)">返回</el-button>
        <!-- <el-button style="float:right" type="primary" class="btn">下载证书</el-button> -->
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { certificateDetail, queryDetail, historyCertificateDetail } from "@/api/certificate";
export default {
  data() {
    return {
      data: {},
    };
  },
  mounted() {
    if (this.$route.params.history === 1) {
      this.historyCertificateDetail();
    } else {
      this.certificateDetail();
    }
  },
  computed:{
    ...mapGetters(['status']),
    token(){
      return this.$route.query.token ? this.$route.query.token:null
    }
  },
  methods: {
    certificateDetail() {
      const apiFunction = this.status ? certificateDetail : queryDetail
      apiFunction(this.$route.params.id,this.token).then((res) => {
        if (res && res.code === 200) {
          this.data = res.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    /* 历史证书详情 */
    historyCertificateDetail() {
      historyCertificateDetail(this.$route.params.id).then((res) => {
        if (res && res.code === 200) {
          this.data = res.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.certificate-detail {
  .container {
    width: 828px;
    min-height: 362px;
    border: 1px solid #eaeaea;
    margin: 30px auto;
    margin-bottom: 80px;
    overflow: hidden;
  }
  .apply-title {
    font-size: 24px;
    color: #363636;
    margin-top: 45px;
    text-align: center;
  }
  .a-list {
    width: 684px;
    margin: 50px auto;
    .item {
      width: 100%;
      min-height: 46px;
      padding-top: 12px;
      padding-bottom: 15px;
      border-bottom: 1px solid #e7e7e7;
      .a-title {
        width: 80px;
        font-size: 14px;
        color: #363636;
        text-align: right;
        white-space: nowrap;
        float: left;
      }
      .a-info {
        width: 420px;
        padding-left: 15px;
        font-size: 14px;
        color: #7a7a7a;
        float: right;
        img {
          width: 122px;
          height: 156px;
        }
      }
    }
  }
  .btn-wrap {
    margin-bottom: 50px;
    overflow: hidden;
    text-align: center;
    width: 684px;
    margin: 0 auto 20px;
    .btn {
      width: 30%;
    }
  }
}
@media screen and (max-width: 768px) {
  .certificate-detail {
    .container {
      width: 90%;
    }
    .apply-title {
    }
    .a-list {
      width: 100%;
      .item {
        .a-title {
        }
        .a-info {
          width: calc(100% - 100px);

          img {
          }
        }
      }
    }
    .btn-wrap {
      width: 100%;
      .btn {
        width: 30%;
      }
    }
  }
}
</style>
